'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

exports.deepGet = deepGet;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @description Gets a property in an object by it's path.
 * @summary
 * The path may contain separators (by default dots) to indicate, that the value should be
 * retrieved from sub-elements of the object. This allows for easy deep querying of objects.
 *
 * If the given path does not exist in the Object, then `undefined` is returned.
 *
 * @example <caption>Simple example: retrieving properties</caption>
 * import { deepGet } from '@nimius/object-utility'
 *
 * const data = { foo: { bar: 'baz' } }
 * deepGet(data, 'foo.bar');
 * // => 'baz'
 *
 *
 * @example <caption>Using custom path separators</caption>
 * import { deepGet } from '@nimius/object-utility'
 *
 * const data = { foo: { bar: { baz: 'test' } } }
 * deepGet(data, 'foo#bar.baz', /[#.]/);
 * // => 'test'
 *
 *
 * @example <caption>Querying for undefined paths</caption>
 * import { deepGet } from '@nimius/object-utility'
 *
 * const data = { foo: 'bar' }
 * deepGet(data, 'bar.baz');
 * // => undefined
 *
 *
 * @param {Object} object - The object to get data from.
 * @param {string} path - The path of the value in the Object. By default dot-notation is used to separate the
 *        different hierarchical layers.
 * @param {string|RegExp} [pathSeparator=.] - The character that separates the path parts. Defaults to a dot, as
 *        dot-notation is the default for expressing object hierarchy.
 * @returns {*|undefined} - The value that exists at the given location or `undefined`, if the path does not exist
 *          in the given object.
 */
function deepGet(object, path) {
    var pathSeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';

    var pathElements = path.split(pathSeparator);
    var lastElement = pathElements.pop();
    var currentObject = object;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(pathElements), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var element = _step.value;

            if (!currentObject[element]) {
                return undefined;
            }
            currentObject = currentObject[element];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return currentObject[lastElement];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/object-utility/src/deep-get.js
// module id = 103
// module chunks = 0 2